/* eslint-disable quote-props */
import {
  AutoLink,
  Bold,
  Essentials,
  FontColor,
  FontSize,
  Heading,
  Italic,
  Link,
  List,
  Markdown,
  Paragraph,
  Table,
  TableCaption,
  TableCellProperties,
  TableColumnResize,
  TableProperties,
  TableToolbar,
  Underline,
  Undo,
} from 'ckeditor5';

const plugins = [
  Bold,
  Essentials,
  Heading,
  Italic,
  Link,
  Paragraph,
  Undo,
  List,
  AutoLink,
  Underline,
  FontColor,
  FontSize,
  Table,
  TableCaption,
  TableCellProperties,
  TableColumnResize,
  TableProperties,
  TableToolbar,
];

export const MARKDOWN_EDITOR_PLUGINS = [...plugins, Markdown];

export const DEFAULT_EDITOR_CONFIG = {
  toolbar: {
    items: ['bold', 'italic', 'underline', '|', 'link', 'numberedList', 'bulletedList'],
    shouldNotGroupWhenFull: false,
  },
  plugins,
  link: {
    addTargetToExternalLinks: true,
    defaultProtocol: 'https://',
    decorators: {
      toggleDownloadable: {
        mode: 'manual' as const,
        label: 'Downloadable',
        attributes: {
          download: 'file',
        },
      },
    },
  },
  table: {
    contentToolbar: ['tableColumn', 'tableRow', 'tableProperties', 'tableCellProperties'],
  },
  fontFamily: {
    supportAllValues: true,
  },
  heading: {
    options: [
      {
        model: 'heading1' as const,
        view: {
          name: 'h1',
          classes: 'custom-title',
        },
        title: 'Title',
        class: 'ck-heading_custom-title',
        converterPriority: 'high',
      },
      {
        model: 'heading2' as const,
        view: {
          name: 'h2',
          classes: 'custom-heading',
        },
        title: 'Heading',
        class: 'ck-heading_custom-heading',
        converterPriority: 'high',
      },
      {
        model: 'paragraph' as const,
        title: 'Paragraph',
        class: 'ck-heading_paragraph',
      },
      {
        model: 'heading3' as const,
        view: {
          name: 'p',
          classes: 'custom-footer',
        },
        title: 'Footer',
        class: 'ck-heading_custom-footer',
        converterPriority: 'high',
      },
      {
        model: 'heading4' as const,
        view: {
          name: 'p',
          classes: 'custom-footnote',
        },
        title: 'Footnote',
        class: 'ck-heading_custom-footnote',
        converterPriority: 'high',
      },
    ],
  },
};
